import "./edit-tenant.scss";

import { LocalRole } from "@core/model/local-role.enum";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { ConfirmDialog } from "primereact/confirmdialog";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormTenant from "../form-tenant/form-tenant";
import { useEditTenant } from "./edit-tenant.hook";

export function EditTenant() {
  const {
    tenantData,
    isLoading,
    tenantError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditTenant();

  const { userRoleIsAdmin } = useUserIdentityContext();

  const title = tenantData?.business_name ? (
    <h1>{tenantData?.business_name}</h1>
  ) : (
    <h1>Edit Tenant</h1>
  );
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        <FormTenant />
      </section>
    </div>
  );

  return (
    <div id="EditTenant" className="tenant">
      <HeaderContent
        title={title}
        backIcon={userRoleIsAdmin() ? <FaChevronLeft /> : null}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>

      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {tenantError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EditTenant;
